var map = {
	"./arbitrum": 437,
	"./arbitrum.tsx": 437,
	"./aurora": 438,
	"./aurora.tsx": 438,
	"./avax": 439,
	"./avax.tsx": 439,
	"./bsc": 440,
	"./bsc.tsx": 440,
	"./celo": 441,
	"./celo.tsx": 441,
	"./cronos": 442,
	"./cronos.tsx": 442,
	"./emerald": 443,
	"./emerald.tsx": 443,
	"./ethereum": 444,
	"./ethereum.tsx": 444,
	"./fantom": 445,
	"./fantom.tsx": 445,
	"./fuse": 446,
	"./fuse.tsx": 446,
	"./harmony": 447,
	"./harmony.tsx": 447,
	"./heco": 448,
	"./heco.tsx": 448,
	"./kava": 449,
	"./kava.tsx": 449,
	"./metis": 450,
	"./metis.tsx": 450,
	"./moonbeam": 451,
	"./moonbeam.tsx": 451,
	"./moonriver": 452,
	"./moonriver.tsx": 452,
	"./optimism": 453,
	"./optimism.tsx": 453,
	"./polygon": 454,
	"./polygon.tsx": 454
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 690;